export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
};

export type CoverSetup = {
  __typename?: 'CoverSetup';
  coverSetupId: Maybe<Scalars['ID']['output']>;
  file: Maybe<Scalars['String']['output']>;
  size: Maybe<CoverSize>;
  x: Maybe<Scalars['Float']['output']>;
  y: Maybe<Scalars['Float']['output']>;
};

export type CoverSize = {
  __typename?: 'CoverSize';
  h: Maybe<Scalars['Int']['output']>;
  w: Maybe<Scalars['Int']['output']>;
};

export type CoverSizeInput = {
  h: Scalars['Int']['input'];
  w: Scalars['Int']['input'];
};

export type CoverUpdateDetails = {
  file: Scalars['String']['input'];
  size: CoverSizeInput;
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type CustomLabel = {
  __typename?: 'CustomLabel';
  language: Maybe<Scalars['String']['output']>;
  text: Maybe<Scalars['String']['output']>;
};

export type CustomLabelInput = {
  language: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type ImageForDisplay = {
  __typename?: 'ImageForDisplay';
  height: Maybe<Scalars['Int']['output']>;
  originalName: Maybe<Scalars['String']['output']>;
  photoGroupHasPhotoId: Scalars['String']['output'];
  photoGroupId: Maybe<Scalars['String']['output']>;
  photoId: Maybe<Scalars['String']['output']>;
  width: Maybe<Scalars['Int']['output']>;
};

export type KeywordsList = {
  __typename?: 'KeywordsList';
  keywordsListId: Maybe<Scalars['ID']['output']>;
  list: Maybe<Array<Maybe<PhotoKeywords>>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  applyProofing: Maybe<TabloProject>;
  cloneTabloTemplate: Maybe<TabloProject>;
  createTabloProject: Maybe<TabloProject>;
  createTabloProjectFromTemplate: Maybe<TabloProject>;
  createTabloTemplateFromProject: Maybe<TabloProject>;
  deleteTabloMemberPhotoPosition: Maybe<MutationStatus>;
  deleteTabloProjectChildren: Maybe<MutationStatus>;
  exportTablosToZalamoPrint: Maybe<Scalars['String']['output']>;
  generateAllOtherChildren: Maybe<MutationStatus>;
  generateMockupFromProject: Maybe<Scalars['String']['output']>;
  placeTemplateOrder: Maybe<Scalars['String']['output']>;
  revokeProofing: Maybe<TabloProject>;
  saveTabloMemberPhotoPosition: Maybe<TabloMemberPhotoPosition>;
  sendTabloToProofing: Maybe<TabloProject>;
  updateTabloProject: Maybe<TabloProject>;
};

export type MutationApplyProofingArgs = {
  tabloProjectId: Scalars['ID']['input'];
};

export type MutationCloneTabloTemplateArgs = {
  height: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  tabloProjectId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
  type: TabloType;
  width: Scalars['Int']['input'];
};

export type MutationCreateTabloProjectArgs = {
  input: TabloProjectInput;
  organizationId: Scalars['ID']['input'];
  tabloProjectId: Scalars['ID']['input'];
};

export type MutationCreateTabloProjectFromTemplateArgs = {
  contextId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  tabloProjectId: Scalars['ID']['input'];
  targetHeight?: InputMaybe<Scalars['Int']['input']>;
  targetWidth?: InputMaybe<Scalars['Int']['input']>;
  templateId: Scalars['ID']['input'];
  zalamoPrintSizeId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationCreateTabloTemplateFromProjectArgs = {
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  sourceTabloProjectId: Scalars['ID']['input'];
  tabloProjectId: Scalars['ID']['input'];
};

export type MutationDeleteTabloMemberPhotoPositionArgs = {
  contextId: Scalars['ID']['input'];
  tabloMemberPhotoPositionId: Scalars['ID']['input'];
};

export type MutationDeleteTabloProjectChildrenArgs = {
  tabloProjectId: Scalars['ID']['input'];
};

export type MutationExportTablosToZalamoPrintArgs = {
  organizationId: Scalars['ID']['input'];
  tabloPrintType?: InputMaybe<TabloPrintType>;
  tabloProjectIds: Array<Scalars['ID']['input']>;
};

export type MutationGenerateAllOtherChildrenArgs = {
  tabloProjectId: Scalars['ID']['input'];
};

export type MutationGenerateMockupFromProjectArgs = {
  ageLevel?: InputMaybe<Scalars['Int']['input']>;
  childStaticPhotos?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  numStudents?: InputMaybe<Scalars['Int']['input']>;
  organizationGroupName?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  schoolLogo?: InputMaybe<Scalars['String']['input']>;
  schoolPhotos?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MutationPlaceTemplateOrderArgs = {
  isRent: Scalars['Boolean']['input'];
  organizationId: Scalars['ID']['input'];
  rentedForContextId?: InputMaybe<Scalars['ID']['input']>;
  templateId: Scalars['ID']['input'];
};

export type MutationRevokeProofingArgs = {
  tabloProjectId: Scalars['ID']['input'];
};

export type MutationSaveTabloMemberPhotoPositionArgs = {
  input: TabloMemberPhotoPositionInput;
};

export type MutationSendTabloToProofingArgs = {
  organizationMemberId: Scalars['ID']['input'];
  tabloProjectId: Scalars['ID']['input'];
};

export type MutationUpdateTabloProjectArgs = {
  input: TabloProjectInput;
  tabloProjectId: Scalars['ID']['input'];
};

export type MutationResponse = {
  __typename?: 'MutationResponse';
  status: Maybe<Scalars['Boolean']['output']>;
};

export type MutationStatus = {
  __typename?: 'MutationStatus';
  status: Maybe<Scalars['Boolean']['output']>;
};

export type NumberRange = {
  __typename?: 'NumberRange';
  max: Maybe<Scalars['Int']['output']>;
  min: Maybe<Scalars['Int']['output']>;
};

export type PhotoKeywords = {
  __typename?: 'PhotoKeywords';
  keywords: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  photoId: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  downloadTabloProjects: Maybe<Scalars['String']['output']>;
  getProjectsForContext: Maybe<Array<Maybe<TabloProject>>>;
  getTabloEditHistory: Array<TabloEditHistoryRevision>;
  getTabloEditHistoryEntry: Maybe<TabloEditHistoryEntry>;
  getTabloMemberPhotoPosition: Maybe<TabloMemberPhotoPosition>;
  getTabloMemberPhotoPositions: Maybe<Array<Maybe<TabloMemberPhotoPosition>>>;
  getTabloProject: Maybe<TabloProject>;
  getTabloProjects: Maybe<Array<Maybe<TabloProject>>>;
};

export type QueryDownloadTabloProjectsArgs = {
  tabloProjectIds: Array<Scalars['ID']['input']>;
};

export type QueryGetProjectsForContextArgs = {
  contextId: Scalars['ID']['input'];
};

export type QueryGetTabloEditHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  tabloProjectId: Scalars['ID']['input'];
};

export type QueryGetTabloEditHistoryEntryArgs = {
  lastHistoryEntryId: Scalars['ID']['input'];
  tabloProjectId: Scalars['ID']['input'];
};

export type QueryGetTabloMemberPhotoPositionArgs = {
  contextId: Scalars['ID']['input'];
  memberId: Scalars['ID']['input'];
};

export type QueryGetTabloMemberPhotoPositionsArgs = {
  contextId: Scalars['ID']['input'];
  memberIds: Array<Scalars['ID']['input']>;
};

export type QueryGetTabloProjectArgs = {
  tabloProjectId: Scalars['ID']['input'];
};

export type QueryGetTabloProjectsArgs = {
  contextId?: InputMaybe<Scalars['ID']['input']>;
  isTemplate: Scalars['Boolean']['input'];
  organizationId: Scalars['ID']['input'];
};

export type QuickLink = {
  __typename?: 'QuickLink';
  label: Maybe<Array<Maybe<CustomLabel>>>;
  link: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  quickLinkId: Maybe<Scalars['ID']['output']>;
};

export type SoldFilesUniversalWatermarkConfig = {
  __typename?: 'SoldFilesUniversalWatermarkConfig';
  horizontal: Maybe<SoldFilesWatermarkConfig>;
  soldFilesUniversalWatermarkConfigId: Maybe<Scalars['ID']['output']>;
  vertical: Maybe<SoldFilesWatermarkConfig>;
};

export type SoldFilesWatermarkConfig = {
  __typename?: 'SoldFilesWatermarkConfig';
  alpha: Maybe<Scalars['Float']['output']>;
  config: Maybe<SoldFilesWatermarkConfigPosition>;
  file: Maybe<Scalars['String']['output']>;
  soldFilesWatermarkConfigId: Maybe<Scalars['ID']['output']>;
};

export type SoldFilesWatermarkConfigPosition = {
  __typename?: 'SoldFilesWatermarkConfigPosition';
  left: Maybe<Scalars['Float']['output']>;
  soldFilesWatermarkConfigPositionId: Maybe<Scalars['ID']['output']>;
  top: Maybe<Scalars['Float']['output']>;
  width: Maybe<Scalars['Float']['output']>;
};

export type SupplierOrderInvoiceDetails = {
  companyBuildingNumber?: InputMaybe<Scalars['String']['input']>;
  companyCity?: InputMaybe<Scalars['String']['input']>;
  companyFlatNumber?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyStreet?: InputMaybe<Scalars['String']['input']>;
  companyVatId?: InputMaybe<Scalars['String']['input']>;
  companyZipCode?: InputMaybe<Scalars['String']['input']>;
};

export type TabloEditHistoryEntry = {
  __typename?: 'TabloEditHistoryEntry';
  action: Scalars['String']['output'];
  authorId: Scalars['ID']['output'];
  authorType: Scalars['String']['output'];
  lastHistoryEntryId: Scalars['ID']['output'];
  previousHistoryEntryId: Maybe<Scalars['ID']['output']>;
  savedAt: Scalars['Int']['output'];
  snapshot: TabloEditHistorySnapshot;
};

export type TabloEditHistoryRevision = {
  __typename?: 'TabloEditHistoryRevision';
  action: Scalars['String']['output'];
  authorId: Scalars['ID']['output'];
  authorType: Scalars['String']['output'];
  lastHistoryEntryId: Scalars['ID']['output'];
  previousHistoryEntryId: Maybe<Scalars['ID']['output']>;
  savedAt: Scalars['Int']['output'];
};

export type TabloEditHistorySnapshot = {
  __typename?: 'TabloEditHistorySnapshot';
  faceMatchConfig: Maybe<Scalars['String']['output']>;
  hasLeadingChild: Maybe<Scalars['Boolean']['output']>;
  height: Maybe<Scalars['Int']['output']>;
  isValid: Maybe<Scalars['Boolean']['output']>;
  leadingChildId: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  pages: Array<Maybe<Scalars['String']['output']>>;
  tabloProjectId: Scalars['ID']['output'];
  type: Maybe<TabloType>;
  width: Maybe<Scalars['Int']['output']>;
};

export type TabloMemberPhotoPosition = {
  __typename?: 'TabloMemberPhotoPosition';
  contextId: Scalars['ID']['output'];
  created: Scalars['Float']['output'];
  groupId: Scalars['ID']['output'];
  height: Scalars['Float']['output'];
  lastUpdate: Scalars['Float']['output'];
  memberId: Scalars['ID']['output'];
  photoId: Scalars['ID']['output'];
  rotation: Scalars['Float']['output'];
  scale: Scalars['Float']['output'];
  tabloMemberPhotoPositionId: Scalars['ID']['output'];
  width: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type TabloMemberPhotoPositionInput = {
  contextId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
  height: Scalars['Float']['input'];
  memberId: Scalars['ID']['input'];
  photoId: Scalars['ID']['input'];
  rotation: Scalars['Float']['input'];
  scale: Scalars['Float']['input'];
  width: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export enum TabloPrintType {
  Fat = 'Fat',
  Smart = 'Smart',
}

export type TabloProject = {
  __typename?: 'TabloProject';
  created: Maybe<Scalars['Int']['output']>;
  faceMatchConfig: Maybe<Scalars['String']['output']>;
  hasLeadingChild: Maybe<Scalars['Boolean']['output']>;
  height: Maybe<Scalars['Int']['output']>;
  isDeleted: Maybe<Scalars['Boolean']['output']>;
  isFromLab: Maybe<Scalars['Boolean']['output']>;
  isMockup: Maybe<Scalars['Boolean']['output']>;
  isRented: Maybe<Scalars['Boolean']['output']>;
  isValid: Maybe<Scalars['Boolean']['output']>;
  labProductId: Maybe<Scalars['ID']['output']>;
  lastHistoryEntryId: Maybe<Scalars['ID']['output']>;
  leadingChildId: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  needsRendering: Maybe<Scalars['Boolean']['output']>;
  pages: Array<Maybe<Scalars['String']['output']>>;
  parentProjectId: Maybe<Scalars['ID']['output']>;
  photoToReplaceCount: Maybe<Scalars['Int']['output']>;
  proofingOrganizationMemberId: Maybe<Scalars['ID']['output']>;
  proofingWaitsForPhotographer: Maybe<Scalars['Boolean']['output']>;
  sentForProofing: Maybe<Scalars['Boolean']['output']>;
  sourcePaidTemplateId: Maybe<Scalars['ID']['output']>;
  subProjectsCount: Maybe<Scalars['Int']['output']>;
  tabloProjectId: Maybe<Scalars['ID']['output']>;
  type: Maybe<TabloType>;
  width: Maybe<Scalars['Int']['output']>;
  zalamoPrintOrderForPhotographerId: Maybe<Scalars['ID']['output']>;
  zalamoPrintSizeId: Maybe<Scalars['ID']['output']>;
};

export type TabloProjectInput = {
  faceMatchConfig?: InputMaybe<Scalars['String']['input']>;
  hasLeadingChild?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isMockup?: InputMaybe<Scalars['Boolean']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
  lastHistoryEntryId?: InputMaybe<Scalars['ID']['input']>;
  leadingChildId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  proofingOrganizationMemberId?: InputMaybe<Scalars['ID']['input']>;
  sentForProofing?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<TabloType>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export enum TabloType {
  SinglePage = 'SinglePage',
  TwoPage = 'TwoPage',
}

export enum ZalamoObject {
  BookingPortfolio = 'BookingPortfolio',
  CompetitionEntry = 'CompetitionEntry',
  Conversation = 'Conversation',
  DesignerAsset = 'DesignerAsset',
  DigitalOrder = 'DigitalOrder',
  LegacyPrivateSessionFileOrder = 'LegacyPrivateSessionFileOrder',
  LookBookOrder = 'LookBookOrder',
  OldZalamoClient = 'OldZalamoClient',
  Order = 'Order',
  Organization = 'Organization',
  OrganizationClient = 'OrganizationClient',
  OrganizationPromoPrintFlyers = 'OrganizationPromoPrintFlyers',
  PrintsOrder = 'PrintsOrder',
  PrivateSession = 'PrivateSession',
  PrivateSessionGroup = 'PrivateSessionGroup',
  Product = 'Product',
  ProductInOrder = 'ProductInOrder',
  PublicSession = 'PublicSession',
  PublicSessionChildren = 'PublicSessionChildren',
  PublicSessionGroup = 'PublicSessionGroup',
  PublicSessionOrganization = 'PublicSessionOrganization',
  PublicSessionOrganizationGroup = 'PublicSessionOrganizationGroup',
  SupportThread = 'SupportThread',
  ZalamoPrintOrder = 'ZalamoPrintOrder',
}
